/** @jsxImportSource @emotion/react */
import { HTMLAttributes, PropsWithChildren } from 'react';

import * as S from './style';
import { LandingTypographyProps, TypographyProps } from '../types/typography';

export default function Typography({
  children,
  variant,
  weight,
  color,
  inlineCss,
  useEllipsis,
  as,
  ...props
}: PropsWithChildren<TypographyProps & HTMLAttributes<HTMLElement>>) {
  return (
    <S.Typography
      variant={variant}
      $color={color}
      weight={weight}
      css={inlineCss}
      as={as}
      useEllipsis={useEllipsis}
      {...props}
    >
      {children}
    </S.Typography>
  );
}

export function LandingTypography({
  children,
  variant,
  weight,
  color,
  inlineCss,
  useEllipsis,
  as,
  ...props
}: PropsWithChildren<LandingTypographyProps & HTMLAttributes<HTMLElement>>) {
  return (
    <S.LandingTypography
      variant={variant}
      $color={color}
      weight={weight}
      css={inlineCss}
      as={as}
      useEllipsis={useEllipsis}
      {...props}
    >
      {children}
    </S.LandingTypography>
  );
}
